export const environment = {
  firebase: {
    apiKey: "AIzaSyAJWbvb4i2W3uWhaMEzFLTSCAkM3keilW0",
    authDomain: "vogo-bus-6f93a.firebaseapp.com",
    projectId: "vogo-bus-6f93a",
    storageBucket: "vogo-bus-6f93a.appspot.com",
    messagingSenderId: "622357613198",
    appId: "1:622357613198:web:5ef56a813957f623f997df"
  },
  VAPIDKEY: 'BJespuHCGXaRO4YdwQtpunBK9h62vqQEnwHlJE0cokI68OlRV73X3JMKaNvWh5udVdN85HG1DPxpBEmHJ28C2As',
  google_api_key: 'AIzaSyBWLWsLeLXb1X7rgxwhBaxl6UnCBykjl60',
  routes_api_key: 'AIzaSyDeJ5xM143_LxsyxSacy36EVeBALiaRbdY',
  production: true,
  STRIP_KEY:"pk_test_s6cToNHgpsPrcwPPnHu5Zevq00VN5oUuax",
  version: '0.0.1 (beta)',
  graphql_endpoint: 'https://graph.vogo.storexweb.team/graphql',
  url: 'https://files.vogo.storexweb.team/',
  places_key: 'AIzaSyAxFKLWDZmhVY2lL5dIUwnflxmeE7ji33s',
  skip_auth: false,
  COMPUTED_ROUTE_MATRIX: 'https://routes.googleapis.com/distanceMatrix/v2:computeRouteMatrix',
  GOOGLE_SCRIPT: 'https://maps.googleapis.com/maps/api/js',
  passengerAndroidApp:'https://play.google.com/store/apps/details?id=com.vogobus.customer_app',
  passengerIOSApp:'https://apps.apple.com/us/app/vogo-bus/id6737807351',
  TIME_IN_MINUTES: 10,
  TRACKING_SOCKET_URL: "https://socket.vogo.storexweb.team/tracking",
  TRACKING_SOCKET_PATH: "/socket.io/tracking",
  CHAT_SOCKET_URL: "https://socket.vogo.storexweb.team/support-chat",
  REPORT_URL: "https://report.vogo.storexweb.team/download-report",
};
